import { Component, OnInit,ViewChild } from '@angular/core';
import { SolarPowerMgtService } from 'app/shared/services/solar-power-mgt.service';
import { Router,ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DialogService } from 'app/shared/services/dialog.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NbThemeService } from '@nebular/theme';
import { AuthService } from 'app/shared/services/auth.service';


@Component({
  selector: 'ngx-solar-power-list',
  templateUrl: './solar-power-list.component.html',
  styleUrls: ['./solar-power-list.component.scss']
})
export class SolarPowerListComponent implements OnInit {

  displayedColumns: string[] = ['RefCode', 'FromDate','FromTime', 'ToDate', 'ToTime','NetExportOrConsume','CreatedBy','Action'];
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dataSource :MatTableDataSource<any>
  searchKey : string;
  
  isDark: boolean = false;

  solarPowerData =[];

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };
 
  

  constructor(private solarPowerService : SolarPowerMgtService,
              private router : Router, 
              private route : ActivatedRoute,
              private toastr: ToastrService,
              private themeService: NbThemeService,
              private authService: AuthService,
              private dialogService: DialogService,) { }

  ngOnInit() {

    this.getAll();
    this.getControlPermissions();
    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });
  }

  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='SP'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }


  getAll(){
    this.solarPowerService.getAll()
     .subscribe(
        (data) => {
                  this.solarPowerData = data;
                  this.dataSource = new  MatTableDataSource (this.solarPowerData);  
                  this.dataSource.sort = this.sort;
                  this.dataSource.paginator = this.paginator;  
                  
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  
       
     }
   
     newCustomerButtonClick(){ 
      this.solarPowerService.dataRow = null;
      this.router.navigate(['../solar-power'],{relativeTo : this.route});
     }

  
     gerRowData(row){   
       this.solarPowerService.dataRow = row;  
       this.router.navigate(['../solar-power'],{relativeTo : this.route});
     
   }

     deleteButtonClick(id : string){

      this.dialogService.openConfirmDialog('Are you sure you want to delete this record?')
      .afterClosed().subscribe(res =>{
        if(res){
          this.solarPowerService.delete(id)
        .subscribe(
          (res) => {
                      this.toastr.success('Record deleted successfully','Success');
                      this.getAll();
                      console.log(res);     
                    },        
          (err) =>  {
                      this.toastr.error('Failed to delete record','Failure');
                      if(err instanceof HttpErrorResponse){                 
                        if(err.status == 401){
                          this.router.navigate(['/login']);
                        }
                      }
                      console.log(err);
                    }, 
            )
        }
      });            
   }

   applyFilter(){
    this.dataSource.filter =this.searchKey.trim().toLowerCase();

   }
   onSearchClear(){
     this.searchKey = "";
     this.applyFilter();
   }


} //end class
